<template>
  <v-card
    class="rounded-xl"
    :border="false"
    :elevation="0"
    v-if="rentalFile">
    <v-row>
      <!--STATUS LIST AT LEFT-->
      <v-col cols="3">
        <!-- 1 CREATED STATUS-->
        <v-row cols="12" class="pb-0">
          <div
            class="status-content"
            :class="isCreatedStatus()"
          >
            <p class="status-detail">
              {{ $t('RENTAL_FILE_GLOBAL_INFO.STATUS_DISPLAY.CREATED') }}
            </p>
            <img
              v-if="isCreatedStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg" />
          </div>
        </v-row>

        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 2 CONTRACT_SENT-->
        <v-row cols="12" class="pb-0">
          <div class="status-content"
               :class="isContractSentStatus()"
               @click="isContractSentStatus() === 'clickable' ?
               openChangeStatusConfirmation() : null"
          >
            <p class="status-detail">
              {{ $t('RENTAL_FILE_GLOBAL_INFO.STATUS_DISPLAY.CONTRACT_SENT') }}
            </p>
            <img
              v-if="isContractSentStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg" />
          </div>
        </v-row>

        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 3 PACKET_PREPARATION-->
        <v-row cols="12" class="pb-0">
          <div class="status-content"
               :class="isPacketPreparationStatus()"
               @click="isPacketPreparationStatus() === 'clickable' ?
               openChangeStatusConfirmation() : null"
          >
            <p class="status-detail">
              {{ $t('RENTAL_FILE_GLOBAL_INFO.STATUS_DISPLAY.PACKET_PREPARATION') }}
            </p>
            <img
              v-if="isPacketPreparationStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg" />
          </div>
        </v-row>

        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 4 TRANSPORT_GO-->
        <v-row cols="12" class="pb-0">
          <div class="status-content"
               :class="isTransportGoStatus()"
               @click="isTransportGoStatus() === 'clickable' ?
               openChangeStatusConfirmation() : null"
          >
            <p class="status-detail">
              {{ $t('RENTAL_FILE_GLOBAL_INFO.STATUS_DISPLAY.TRANSPORT_GO') }}
            </p>
            <img
              v-if="isTransportGoStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg" />
          </div>
        </v-row>

        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 5 CLIENT_RECEIPT-->
        <v-row cols="12" class="pb-0">
          <div class="status-content"
               :class="isClientReceiptStatus()"
               @click="isClientReceiptStatus() === 'clickable' ?
               openChangeStatusConfirmation() : null"
          >
            <p class="status-detail">
              {{ $t('RENTAL_FILE_GLOBAL_INFO.STATUS_DISPLAY.CLIENT_RECEIPT') }}
            </p>
            <img
              v-if="isClientReceiptStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg" />
          </div>
        </v-row>

        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 6 CLIENT_INFORMED-->
        <v-row cols="12" class="pb-0">
          <div class="status-content"
               :class="isClientInformedStatus()"
               @click="isClientInformedStatus() === 'clickable' ?
                openClientInformedChangeStatusConfirmation() : null">
            <p class="status-detail">
              {{ $t('RENTAL_FILE_GLOBAL_INFO.STATUS_DISPLAY.CLIENT_INFORMED') }}
            </p>
            <img
              v-if="isClientInformedStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg" />
          </div>
        </v-row>

        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 7 STORE_RECEIPT-->
        <v-row cols="12" class="pb-0">
          <div class="status-content"
               :class="isStoreReceiptStatus()"
               @click="isStoreReceiptStatus() === 'clickable' ?
                openStoreReceiptChangeStatusConfirmation() : null">
            <p class="status-detail">
              {{ $t('RENTAL_FILE_GLOBAL_INFO.STATUS_DISPLAY.STORE_RECEIPT') }}
            </p>
            <img
              v-if="isStoreReceiptStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg" />
          </div>
        </v-row>

        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 8 TRANSPORT_BACK-->
        <v-row cols="12" class="pb-0">
          <div class="status-content"
               :class="isTransportBackStatus()"
               @click="isTransportBackStatus() === 'clickable' ?
                openChangeStatusConfirmation() : null">
            <p class="status-detail">
              {{ $t('RENTAL_FILE_GLOBAL_INFO.STATUS_DISPLAY.TRANSPORT_BACK') }}
            </p>
            <img
              v-if="isTransportBackStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg" />
          </div>
        </v-row>

        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 9 BOOMERANG_RECEIPT-->
        <v-row cols="12" class="pb-0">
          <div class="status-content"
               :class="isBoomerangReceiptStatus()"
               @click="isBoomerangReceiptStatus() === 'clickable' ?
               openChangeStatusConfirmation() : null"
          >
            <p class="status-detail">
              {{ $t('RENTAL_FILE_GLOBAL_INFO.STATUS_DISPLAY.BOOMERANG_RECEIPT') }}
            </p>
            <img
              v-if="isBoomerangReceiptStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg" />
          </div>
        </v-row>

        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 10 BILLING-->
        <v-row cols="12" class="pb-0">
          <div class="status-content"
               :class="isBillingStatus()"
               @click="isBillingStatus() === 'clickable' ?
               openChangeStatusConfirmation() : null"
          >
            <p class="status-detail">
              {{ $t('RENTAL_FILE_GLOBAL_INFO.STATUS_DISPLAY.BILLING') }}
            </p>
            <img
              v-if="isBillingStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg" />
          </div>
        </v-row>

        <v-row class="divider">
          <v-divider vertical length="10px" />
        </v-row>

        <!-- 11 CLOSED-->
        <v-row cols="12" class="pb-0">
          <div class="status-content"
               :class="isClosedStatus()"
               @click="isClosedStatus() === 'clickable' ?
               openChangeStatusConfirmation() : null"
          >
            <p class="status-detail">
              {{ $t('RENTAL_FILE_GLOBAL_INFO.STATUS_DISPLAY.CLOSED') }}
            </p>
            <img
              v-if="isClosedStatus() === 'outdated-status'"
              alt="dialog-icon"
              class="svg-check-rounded"
              src="@/assets/icons/file/check_round.svg" />
          </div>
        </v-row>
      </v-col>

      <!--Global informations-->
      <v-col cols="9">
        <!--TITLE AND Days Open count-->
        <v-row class="header-content">
          <v-col cols="4" class="pl-0 justify-start d-flex">
            <p class="title">{{ $t('RENTAL_FILE_GLOBAL_INFO.HEADER.TITLE') }}</p>
          </v-col>
          <v-col cols="4" class="pr-0 justify-center d-flex">
            <p class="day-count">{{ calculateDate() }}</p>
          </v-col>
          <v-col cols="4" class="pr-0 justify-end d-flex">
          </v-col>
        </v-row>

        <!--PRODUCT CARD-->
        <v-row>
          <v-col cols="2">
            <v-img :src="rentalFile?.product_picture" class="picture-content" alt="Image produit" />
          </v-col>
          <v-col cols="10">
            <v-row>
              <v-col class="px-0 pb-1" cols="12">
                <p class="sub-title">{{ $t('RENTAL_FILE_GLOBAL_INFO.RENTAL_FILE_INFO.TITLE.PRODUCT') }}</p>
                <div class="underline" />
              </v-col>
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('RENTAL_FILE_GLOBAL_INFO.RENTAL_FILE_INFO.MANUFACTURER') }}
                </p>
                <p class="text">
                  {{ rentalFile.product_manufacturer_name_ref ? rentalFile.product_manufacturer_name_ref : '-' }}
                </p>
              </v-col>
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('RENTAL_FILE_GLOBAL_INFO.RENTAL_FILE_INFO.CATEGORY') }}
                </p>
                <p class="text">
                  {{ rentalFile.product_category ? rentalFile.product_category : '-' }}
                </p>
              </v-col>
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('RENTAL_FILE_GLOBAL_INFO.RENTAL_FILE_INFO.SUB_CATEGORY') }}
                </p>
                <p class="text">
                  {{
                    rentalFile.product_sub_category ? rentalFile.product_sub_category : '-'
                  }}
                </p>
              </v-col>
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('RENTAL_FILE_GLOBAL_INFO.RENTAL_FILE_INFO.PRODUCT') }}
                </p>
                <p class="text">
                  {{ rentalFile.product_name ? rentalFile.product_name : '-' }}
                </p>
              </v-col>
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('RENTAL_FILE_GLOBAL_INFO.RENTAL_FILE_INFO.SERIAL_NUMBER') }}
                </p>
                <p class="text">
                  {{ rentalFile.product_serial_number ? rentalFile.product_serial_number : '-' }}
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!--CONTACT CARD-->
        <v-row>
          <v-col cols="12">
            <v-row>
              <v-col class="px-0 pb-1" cols="12">
                <p class="sub-title">{{ $t('RENTAL_FILE_GLOBAL_INFO.RENTAL_FILE_INFO.TITLE.CONTACT') }}</p>
                <div class="underline" />
              </v-col>
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">{{ $t('RENTAL_FILE_GLOBAL_INFO.RENTAL_FILE_INFO.LASTNAME') }}</p>
                <p class="text">
                  {{ rentalFile.client_name ? rentalFile.client_name : '-' }}
                </p>
              </v-col>
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('RENTAL_FILE_GLOBAL_INFO.RENTAL_FILE_INFO.EMAIL') }}
                </p>
                <p class="text">{{ rentalFile.client_email ? rentalFile.client_email : '-' }}</p>
              </v-col>
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('RENTAL_FILE_GLOBAL_INFO.RENTAL_FILE_INFO.PHONE_NUMBER') }}
                </p>
                <p class="text">
                  {{
                    rentalFile.client_phone ? rentalFile.client_phone : '-'
                  }}
                </p>
              </v-col>
            </v-row>
          </v-col>
        </v-row>

        <!--PRICING CARD-->
        <v-row>
          <v-col cols="12">
            <v-row>
              <!--TITLE-->
              <v-col class="px-0 pb-1" cols="12">
                <p class="sub-title">{{ $t('RENTAL_FILE_GLOBAL_INFO.RENTAL_FILE_INFO.TITLE.PRICING') }}</p>
                <div class="underline" />
              </v-col>

              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('RENTAL_FILE_GLOBAL_INFO.RENTAL_FILE_INFO.CLIENT_RENTAL_COST') }}
                </p>
                <p class="text">
                  {{ rentalFile.rental_client_cost ? rentalFile.rental_client_cost.toFixed(2) + ' €' : '-' }}
                </p>
              </v-col>
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between mb-3" cols="12">
                <p class="text grey">
                  {{ $t('RENTAL_FILE_GLOBAL_INFO.RENTAL_FILE_INFO.CLIENT_RENTAL_COST_PACKAGE_NAME') }}
                </p>
                <p class="text">
                  {{ rentalFile.rental_file_package_boomerang_id
                  ? rentalFile.rental_file_package_boomerang_id : '-' }}
                </p>
              </v-col>

              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('RENTAL_FILE_GLOBAL_INFO.RENTAL_FILE_INFO.CLIENT_ADDITIONAL_DAY_COST') }}
                </p>
                <p class="text">
                  {{ rentalFile.rental_client_additional_days_cost
                  ? rentalFile.rental_client_additional_days_cost.toFixed(2) + ' €' : '-' }}
                </p>
              </v-col>
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between mb-3" cols="12">
                <p class="text grey">
                  {{ $t('RENTAL_FILE_GLOBAL_INFO.RENTAL_FILE_INFO.CLIENT_ADDITIONAL_DAY_PACKAGE_NAME') }}
                </p>
                <p class="text">
                  {{ rentalFile.rental_file_additional_cost_boomerang_id
                  ? rentalFile.rental_file_additional_cost_boomerang_id : '-' }}
                </p>
              </v-col>

              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('RENTAL_FILE_GLOBAL_INFO.RENTAL_FILE_INFO.DEPOSIT') }}
                </p>
                <p class="text">
                  {{ rentalFile.rental_deposit ? rentalFile.rental_deposit.toFixed(2) + ' €' : '-' }}
                </p>
              </v-col>
              <v-col class="px-0 pt-0 pb-1 d-flex justify-space-between" cols="12">
                <p class="text grey">
                  {{ $t('RENTAL_FILE_GLOBAL_INFO.RENTAL_FILE_INFO.DEPOSIT_TYPE') }}
                </p>
                <p class="text">
                  {{ rentalFile.rental_deposit_type ?
                  $t('RENTAL_FILE_GLOBAL_INFO.DEPOSIT_TYPE.' + rentalFile.rental_deposit_type) : '-' }}
                </p>
              </v-col>
            </v-row >
          </v-col>
        </v-row>

      </v-col>
    </v-row>
  </v-card>

  <UpdateStatusConfirmationModal ref="updateRentalFileStatusConfirmationModal" />
  <UpdateStatusClientInformedModal ref="updateRentalFileClientInformedModal" />
  <UpdateStatusStoreReceiptModal ref="updateRentalFileStoreReceiptModal" />
</template>

<script>
import RentalFileStatusConstant from '@/constants/rentalModule/rentalFileStatusConstant'
import RentalFileService from '@/services/rentalModule/RentalFileService'
import ResponseConstant from '@/constants/responseConstant'
import { displayToast, checkPermission } from '@/components/utils/globalFunction'
import UpdateStatusClientInformedModal
  from '@/components/modal/rentalModule/rentalFile/UpdateStatusClientInformedModal.vue'
import UpdateStatusStoreReceiptModal from '@/components/modal/rentalModule/rentalFile/UpdateStatusStoreReceiptModal.vue'
import UpdateStatusConfirmationModal from '@/components/modal/rentalModule/rentalFile/UpdateStatusConfirmationModal.vue'

export default {
  name: 'GlobalRentalFileInfo',
  components: { UpdateStatusConfirmationModal, UpdateStatusStoreReceiptModal, UpdateStatusClientInformedModal },
  props: {
    rentalFileId: Number
  },
  data() {
    return {
      loading: false,
      error: null,

      rentalFile: null
    }
  },
  async created() {
    await this.getRentalFileDetail()
  },
  methods: {

    checkPermission,
    async getRentalFileDetail() {
      try {
        this.rentalFile = await RentalFileService.getRentalFileDetail(this.rentalFileId)
      } catch (error) {
        if (error.response?.data && error.response.data.key in ResponseConstant) {
          displayToast(this.$t('ERROR.' + ResponseConstant[error.response.data.key]), 'error')
        } else {
          displayToast(this.$t('ERROR_STATUS_CODE_MESSAGE.'
              + (error.response ? error.response.status : 'UNKNOWN')), 'error')
        }
      }
    },
    isCreatedStatus() {
      if (this.rentalFile.rental_file_status === RentalFileStatusConstant.CREATED) {
        return 'active-status'
      } else {
        return 'outdated-status'
      }
    },
    isContractSentStatus() {
      if (this.rentalFile.rental_file_status === RentalFileStatusConstant.CONTRACT_SENT) {
        return 'active-status'
      } else if (this.isCreatedStatus() === 'outdated-status') {
        return 'outdated-status'
      } else if (this.rentalFile.rental_file_status === RentalFileStatusConstant.CREATED) {
        return 'clickable'
      } else {
        return ''
      }
    },
    isPacketPreparationStatus() {
      if (this.rentalFile.rental_file_status === RentalFileStatusConstant.PACKET_PREPARATION) {
        return 'active-status'
      } else if (this.isCreatedStatus() === 'outdated-status'
        && this.isContractSentStatus() === 'outdated-status') {
        return 'outdated-status'
      } else if (this.rentalFile.rental_file_status === RentalFileStatusConstant.CONTRACT_SENT) {
        return 'clickable'
      } else {
        return ''
      }
    },
    isTransportGoStatus() {
      if (this.rentalFile.rental_file_status === RentalFileStatusConstant.TRANSPORT_GO) {
        return 'active-status'
      } else if (this.isCreatedStatus() === 'outdated-status'
        && this.isContractSentStatus() === 'outdated-status'
        && this.isPacketPreparationStatus() === 'outdated-status') {
        return 'outdated-status'
      } else if (this.rentalFile.rental_file_status === RentalFileStatusConstant.PACKET_PREPARATION) {
        return 'clickable'
      } else {
        return ''
      }
    },
    isClientReceiptStatus() {
      if (this.rentalFile.rental_file_status === RentalFileStatusConstant.CLIENT_RECEIPT) {
        return 'active-status'
      } else if (this.isCreatedStatus() === 'outdated-status'
        && this.isContractSentStatus() === 'outdated-status'
        && this.isPacketPreparationStatus() === 'outdated-status'
        && this.isTransportGoStatus() === 'outdated-status') {
        return 'outdated-status'
      } else if (this.rentalFile.rental_file_status === RentalFileStatusConstant.TRANSPORT_GO) {
        return 'clickable'
      } else {
        return ''
      }
    },
    isClientInformedStatus() {
      if (this.rentalFile.rental_file_status === RentalFileStatusConstant.CLIENT_INFORMED) {
        return 'active-status'
      } else if (this.isCreatedStatus() === 'outdated-status'
        && this.isContractSentStatus() === 'outdated-status'
        && this.isPacketPreparationStatus() === 'outdated-status'
        && this.isTransportGoStatus() === 'outdated-status'
        && this.isClientReceiptStatus() === 'outdated-status') {
        return 'outdated-status'
      } else if (this.rentalFile.rental_file_status === RentalFileStatusConstant.CLIENT_RECEIPT) {
        return 'clickable'
      } else {
        return ''
      }
    },
    isStoreReceiptStatus() {
      if (this.rentalFile.rental_file_status === RentalFileStatusConstant.STORE_RECEIPT) {
        return 'active-status'
      } else if (this.isCreatedStatus() === 'outdated-status'
        && this.isContractSentStatus() === 'outdated-status'
        && this.isPacketPreparationStatus() === 'outdated-status'
        && this.isTransportGoStatus() === 'outdated-status'
        && this.isClientReceiptStatus() === 'outdated-status'
        && this.isClientInformedStatus() === 'outdated-status') {
        return 'outdated-status'
      } else if (this.rentalFile.rental_file_status === RentalFileStatusConstant.CLIENT_INFORMED) {
        return 'clickable'
      } else {
        return ''
      }
    },
    isTransportBackStatus() {
      if (this.rentalFile.rental_file_status === RentalFileStatusConstant.TRANSPORT_BACK) {
        return 'active-status'
      } else if (this.isCreatedStatus() === 'outdated-status'
        && this.isContractSentStatus() === 'outdated-status'
        && this.isPacketPreparationStatus() === 'outdated-status'
        && this.isTransportGoStatus() === 'outdated-status'
        && this.isClientReceiptStatus() === 'outdated-status'
        && this.isClientInformedStatus() === 'outdated-status'
        && this.isStoreReceiptStatus() === 'outdated-status') {
        return 'outdated-status'
      } else if (this.rentalFile.rental_file_status === RentalFileStatusConstant.STORE_RECEIPT) {
        return 'clickable'
      } else {
        return ''
      }
    },
    isBoomerangReceiptStatus() {
      if (this.rentalFile.rental_file_status === RentalFileStatusConstant.BOOMERANG_RECEIPT) {
        return 'active-status'
      } else if (this.isCreatedStatus() === 'outdated-status'
        && this.isContractSentStatus() === 'outdated-status'
        && this.isPacketPreparationStatus() === 'outdated-status'
        && this.isTransportGoStatus() === 'outdated-status'
        && this.isClientReceiptStatus() === 'outdated-status'
        && this.isClientInformedStatus() === 'outdated-status'
        && this.isStoreReceiptStatus() === 'outdated-status'
        && this.isTransportBackStatus() === 'outdated-status') {
        return 'outdated-status'
      } else if (this.rentalFile.rental_file_status === RentalFileStatusConstant.TRANSPORT_BACK) {
        return 'clickable'
      } else {
        return ''
      }
    },
    isBillingStatus() {
      if (this.rentalFile.rental_file_status === RentalFileStatusConstant.BILLING) {
        return 'active-status'
      } else if (this.isCreatedStatus() === 'outdated-status'
        && this.isContractSentStatus() === 'outdated-status'
        && this.isPacketPreparationStatus() === 'outdated-status'
        && this.isTransportGoStatus() === 'outdated-status'
        && this.isClientReceiptStatus() === 'outdated-status'
        && this.isClientInformedStatus() === 'outdated-status'
        && this.isStoreReceiptStatus() === 'outdated-status'
        && this.isTransportBackStatus() === 'outdated-status'
        && this.isBoomerangReceiptStatus() === 'outdated-status') {
        return 'outdated-status'
      } else if (this.rentalFile.rental_file_status === RentalFileStatusConstant.BOOMERANG_RECEIPT) {
        return 'clickable'
      } else {
        return ''
      }
    },
    isClosedStatus() {
      if (this.rentalFile.rental_file_status === RentalFileStatusConstant.CLOSED) {
        return 'active-status'
      } else if (this.rentalFile.rental_file_status === RentalFileStatusConstant.BILLING) {
        return 'clickable'
      } else {
        return ''
      }
    },
    calculateDate() {
      if (!this.rentalFile.rental_file_opened_since_days) {
        return '0 ' + this.$t('RENTAL_FILE_GLOBAL_INFO.HEADER.DAY')
      }
      if (this.rentalFile.rental_file_opened_since_days > 1) {
        return this.rentalFile.rental_file_opened_since_days + ' ' + this.$t('RENTAL_FILE_GLOBAL_INFO.HEADER.DAYS')
      } else {
        return this.rentalFile.rental_file_opened_since_days + ' ' + this.$t('RENTAL_FILE_GLOBAL_INFO.HEADER.DAY')
      }
    },
    async openClientInformedChangeStatusConfirmation() {
      const statusUpdated = await this.$refs.updateRentalFileClientInformedModal.show({
        currentRentalFile: this.rentalFile
      })

      if (statusUpdated) {
        await this.getRentalFileDetail()
        this.$emit('updateRentalFile')
      }
    },
    async openStoreReceiptChangeStatusConfirmation() {
      const statusUpdated = await this.$refs.updateRentalFileStoreReceiptModal.show({
        currentRentalFile: this.rentalFile
      })

      if (statusUpdated) {
        await this.getRentalFileDetail()
        this.$emit('updateRentalFile')
      }
    },
    async openChangeStatusConfirmation() {
      const statusUpdated = await this.$refs.updateRentalFileStatusConfirmationModal.show({
        currentRentalFile: this.rentalFile
      })

      if (statusUpdated) {
        await this.getRentalFileDetail()
        this.$emit('updateRentalFile')
      }
    }
  }
}
</script>

<style scoped>
.v-card {
  padding: 32px;
  overflow: unset;
}

.header-content {
  display: flex;
  align-items: center;
  align-self: stretch;
}

.title {
  color: #000;
  font-size: 18px;
  font-style: normal;
  font-weight: 900;
  line-height: normal;
}

.button {
  border-radius: 20px;
  background: #000;
}

.cross-rounded-svg {
  width: 14px;
  height: 14px;
  filter: invert(100%) sepia(0%) saturate(7481%) hue-rotate(181deg) brightness(108%) contrast(100%);
  margin-right: 4px;
}

.btn-label {
  color: #FFF;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
}

.status-detail {
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 18px */
  letter-spacing: -0.132px;
}

.status-content {
  width: fit-content;
  display: flex;
  padding: 4px 10px;
  align-items: center;
  gap: 10px;
  border-radius: 10px;
  color: #ACACAC;
  background: white;
}

.svg-check-rounded {
  width: 14px;
  height: 14px;
}

.picture-content {
  width: 83px;
  height: 83px;
}

.sub-title {
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  display: flex;
}

.text {
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  color: black;
}

.grey {
  color: #ACACAC;
}

.bold {
  font-weight: bold;
}

.underline {
  height: 1px;
  background: black;
}

.total-row-container {
  position: relative;
  top: 35px;
}

.total-content {
  display: flex;
  width: 100%;
  height: 32px;
  flex: 1 0 0;
  border-radius: 20px 20px 20px 20px;
  background: #FAFAFA;
  flex-direction: row;
  flex-wrap: nowrap;
  align-content: center;
  justify-content: space-between;
}

.client-validation {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 5px 10px;
  border-radius: 20px 0 0 20px;
  background: #165039;
  color: white;
  min-width: 230px;
}

.repair-content {
  color: white;
  display: flex;
  align-items: center;
  border-radius: 5px;
  margin-left: 10px;
  padding-left: 5px;
  padding-right: 5px;
  border: 1px solid white;
}

.total-price {
  color: black;
  display: flex;
  padding-right: 10px;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  align-content: center;
}

.divider {
  min-height: 10px;
  margin-left: 6px;
}

.active-status {
  background-color: #86C94E;
  color: black;
}

.outdated-status {
  background-color: #EFEFEF;
  color: black;
}

.clickable {
  cursor: pointer;
}

.day-count {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
</style>
